<template>
  <div>
    <div style="display: flex">
      <div style="margin-left: auto">
        <button class="btn" @click="() => openModal(null, 'new')">{{ i18nJS.add_item }}</button>
      </div>
    </div>
    <generic-table
      :headerLabels="headerLabels"
      :elements="getTableElements"
      :options="options"
      @editEvent="(el) => openModal(el, 'edit')"
      @removeElementEvent="(el) => removeItem(el)"
    />

    <div
      aria-hidden="true"
      aria-labelledby="myModalLabel"
      data-backdrop="static"
      data-keyboard="false"
      class="modal fade"
      id="modal-kit-modify"
      role="dialog"
      style="min-width: 680px"
    >
      <div class="modal-header">
        <h3 class="modal-title">
          {{ i18nJS.change_request }}
        </h3>
      </div>
      <div class="modal-body">
        <template v-if="modalType == 'new'">
          <activities-briefcase @changedItemsEvent="(items) => changedItems(items)"></activities-briefcase>
        </template>
        <template v-if="modalType == 'edit'">
          <ul id="activity-items">
            <li>
              <span>
                <input type="number" class="input-micro" placeholder="Qta" v-model="itemSelected.qta" style="margin-right: 16px" />
                {{ itemSelected.item_desc }}
              </span>
            </li>
          </ul>
        </template>
      </div>
      <div class="modal-footer">
        <button aria-hidden="true" class="btn" data-dismiss="modal" @click="closeModal(itemSelected)">{{ i18nJS.command.apply }}</button>
      </div>
    </div>
  </div>
</template>
<script>
import apiConnector from '@/epersonam/apiConnector';
import genericTable from '../genericTable/genericTable';
import { GenericTableEditButton } from '../models/genericTableButtons/editButton';
import activitiesBriefcase from '../activity/activitiesBriefcase';

export default {
  name: 'briefcases',
  components: {
    genericTable,
    activitiesBriefcase,
  },
  props: ['urlDomestics', 'saveAct'],
  data() {
    return {
      modalType: null,
      orderList: 'unsend',
      error: false,
      briefcases: [],
      userId: null,
      itemSelected: {},
      newItems: [],
      dismissSecs: 5,
      expected_consumptions: [],
      headerLabels: ['Articolo', 'Qta', 'Formato'],
      options: {
        actionColumnEnabled: true,
        canDeleteRow: true,
        actionButtons: [new GenericTableEditButton()],
      },
    };
  },
  computed: {
    i18nJS() {
      return window.i18nJS;
    },
    getTableElements() {
      return this.expected_consumptions;
    },
  },
  mounted() {
    $('.save-briefcases').click(() => {
      this.saveActivitiesBriefcases();
    });
    $('#date-search-button').click(() => {
      this.loadActivitiesBriefcases();
    });
    this.loadActivitiesBriefcases();
  },
  methods: {
    changedItems(newItems) {
      this.newItems = newItems.map((item) => {
        return {
          item_desc: item.name,
          qta: item.qta,
          conv: item.item_udm,
          metadata: { item_id: item.w_item_id, conv_id: item.w_conv_id },
        };
      });
    },
    removeItem(item) {
      const index = this.expected_consumptions.findIndex((ec) => (ec.metadata && ec.metadata.item_id) == item.metadata.item_id);
      this.$delete(this.expected_consumptions, index);
    },
    openModal(item, modalType) {
      this.modalType = modalType;
      this.itemSelected = item;
      $('#modal-kit-modify').modal('show');
    },
    closeModal() {
      if (this.modalType == 'edit') {
        this.$set(
          this.expected_consumptions,
          this.expected_consumptions.findIndex((i) => i.item_id == this.itemSelected.metadata.item_id),
          this.itemSelected,
        );
        this.itemSelected = {};
      } else if (this.modalType == 'new') {
        this.expected_consumptions = [...this.expected_consumptions, ...this.newItems];
        this.newItems = [];
      }
      this.modalType = null;
    },
    loadActivitiesBriefcases() {
      this.expected_consumptions = [];
      this.error = false;
      Loader.show();
      apiConnector()
        .get(this.urlDomestics, {
          params: {
            from: $('#date-search-from').val(),
            to: $('#date-search-to').val(),
          },
        })
        .then((res) => {
          this.briefcases = res.data.expected_consumptions;
          this.briefcases.forEach((briefcase) => {
            briefcase.item_consumptions
              .filter((item_consumption) => item_consumption.status != 8)
              .forEach((item_consumption) => {
                const ex_c = this.expected_consumptions.find((ec) => (ec.metadata && ec.metadata.item_id) == item_consumption.item_id);
                if (ex_c != null) {
                  ex_c.qta += item_consumption.qta;
                } else {
                  this.expected_consumptions.push({
                    item_desc: item_consumption.item_desc,
                    qta: item_consumption.qta,
                    conv: item_consumption.conv == null ? 'Confezione' : item_consumption.conv.format,
                    metadata: { item_id: item_consumption.item_id, conv_id: item_consumption.conv ? item_consumption.conv.id : null },
                  });
                }
              });
          });
          this.userId = res.data.user_id;
          Loader.hide();
        })
        .catch((err) => {
          Loader.hide();
          this.error = true;
        });
    },
    saveActivitiesBriefcases() {
      this.error = false;
      Loader.show();
      apiConnector()
        .post(this.saveAct, {
          elements: this.briefcases.filter((el) => el.type == 'briefcase_item'),
          items: this.expected_consumptions.map((expected_consumption) => {
            return {
              item_id: expected_consumption.metadata.item_id,
              qta: expected_consumption.qta,
              conv_id: expected_consumption.metadata.conv_id,
            };
          }),
        })
        .then((res) => {
          Loader.hide();
          this.loadActivitiesBriefcases();
          this.orderList = 'send';
          window.alert('Ordine inviato');
        })
        .catch((err) => {
          Loader.hide();
          alert('Salvataggio non completato');
          this.error = true;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.itemKit {
  list-style-type: none;
  margin: 0 0 5px 0;
  li {
    padding: 2px;
  }
}
#activity-items {
  list-style-type: none;
  li {
    padding: 3px;
  }
  li:hover {
    background-color: #f8f8f8;
  }
}
.delete-icon {
  float: right;
}
.input-micro {
  margin-bottom: 0px;
}
</style>
